import { useEffect, useState } from 'react'

const useGeolocation = (): GeolocationPosition | undefined => {
  const [position, setPosition] = useState<GeolocationPosition>()
  useEffect(() => {
    if ('geolocation' in navigator) {
      // Geolocation is used to pre-fill the location field when registering a sample.
      // The browser will prompt the user for permission before any data is accessed.
      navigator.geolocation.getCurrentPosition(function (position) {
        setPosition(position)
      })
    } else {
      console.log('Geolocation is not available')
    }
  }, [])

  return position
}

export default useGeolocation
